export * from './ans'
export * from './draft-js'
export * from './draft-js-plugins'
export * from './redux'
export * from './settings'
export * from './pubstack'
export * from './site-service'
export * from './author'

export interface ComposerApiErrorResponse {
  error: {
    statusCode: number
    errorKey: string
    errorData: unknown
  }
}

export interface ScheduledEvents {
  content_ref: {
    ans_object: {
      story_id: string
      type: 'story_operation'
    }
    id: string
    operation_type: 'story_operation'
  }
  schedule: Array<{
    date: string
    job_type: 'publish' | 'unpublish'
  }>
}
